var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { clickedBackButton, navigatedBack } from "../lib/Avo";
import { NAIVAGATE_BACK_TRIGGERED_BY_TYPES } from "../lib/TrellisAnalytics";
import useAppSelector from "./useAppSelector";
import { useHistory } from "react-router-dom";
export default function useHandleBackClick(goBackOverride) {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var goBack = useHistory().goBack;
    return function handleBackClick() {
        navigatedBack(__assign(__assign({}, commonAnalyticsProperties), { triggeredBy: NAIVAGATE_BACK_TRIGGERED_BY_TYPES.USER_CLICK }));
        clickedBackButton(commonAnalyticsProperties);
        if (goBackOverride) {
            return goBackOverride();
        }
        goBack();
    };
}
